import { log } from './log.js';

export const HISTORY_SCHEMA_VERSION = 2;
const CURRENT_KEY = 'plant-id:current-session';
const HISTORY_KEY = 'plant-id:history';
const MAX_HISTORY = 200;

export interface SavedSession {
  schemaVersion: number;
  sessionId: string;
  phase: string;
  messages: Array<{ role: 'user' | 'assistant'; text: string; at: number }>;
}

export function saveCurrentSession(s: SavedSession): void {
  try {
    localStorage.setItem(CURRENT_KEY, JSON.stringify({ ...s, schemaVersion: HISTORY_SCHEMA_VERSION }));
  } catch (err) {
    log.warn('saveCurrentSession failed', err);
  }
}

export function loadCurrentSession(): SavedSession | null {
  const raw = localStorage.getItem(CURRENT_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as SavedSession;
    if (parsed.schemaVersion !== HISTORY_SCHEMA_VERSION) {
      localStorage.removeItem(CURRENT_KEY);
      return null;
    }
    return parsed;
  } catch (err) {
    log.warn('loadCurrentSession corruption — clearing', err);
    localStorage.removeItem(CURRENT_KEY);
    return null;
  }
}

export function clearCurrentSession(): void {
  localStorage.removeItem(CURRENT_KEY);
}

export function pushCompletedId(speciesId: string): void {
  const cur = loadCompletedIds();
  const filtered = cur.filter(id => id !== speciesId);
  filtered.push(speciesId);
  const clipped = filtered.slice(-MAX_HISTORY);
  try {
    localStorage.setItem(HISTORY_KEY, JSON.stringify(clipped));
  } catch (err) {
    log.warn('pushCompletedId failed', err);
  }
}

export function loadCompletedIds(): string[] {
  const raw = localStorage.getItem(HISTORY_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as string[];
    if (!Array.isArray(parsed)) {
      localStorage.removeItem(HISTORY_KEY);
      return [];
    }
    return parsed;
  } catch (err) {
    log.warn('loadCompletedIds corruption — clearing', err);
    localStorage.removeItem(HISTORY_KEY);
    return [];
  }
}
